import React from 'react';
import { Link, useStaticQuery, graphql } from 'gatsby';
import { getImage } from 'gatsby-plugin-image';

const FeaturedCards = () => {
    const data = useStaticQuery(graphql`
        query {
            appImage: file(relativePath: { eq: "app.jpg" }) {
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                }
            }
            webinarsImage: file(relativePath: { eq: "Webinars.jpg" }) {
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                }
            }
            reviewsImage: file(relativePath: { eq: "reviews.jpg" }) {
                childImageSharp {
                    gatsbyImageData(layout: FULL_WIDTH)
                }
            }
        }
    `);

    const appImage = getImage(data.appImage);
    const webinarsImage = getImage(data.webinarsImage);
    const reviewsImage = getImage(data.reviewsImage);

    return (
        <section className="py-10 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mx-auto text-center">
            <div className="col-span-full lg:col-span-10 lg:col-start-2 lg:col-end-12">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 xl:gap-10">
                {appImage && (
                  <div className="card relative bg-cover bg-center aspect-square rounded-3xl sm:col-span-1 md:col-span-1" style={{ backgroundImage: `url(${appImage.images.fallback.src})` }}>
                    <div className="absolute inset-0 bg-black bg-opacity-0 flex flex-col justify-between p-8 md:px-4 xl:p-8 rounded-3xl">
                      <div className="text-left text-white">
                        <p className="featured-card-text pb-1 text-xl md:text-sm xl:text-xl">The Holborn App</p>
                        <h3 className="featured-card-title text-2xl md:text-lg xl:text-3xl font-medium pt-0 mt-0">Your money in your pocket</h3>
                      </div>
                      <div className="text-right">
                        <Link to="/who-we-are/introducing-the-holborn-app/" className="card-button mt-3 bg-white text-black py-2 px-4 rounded-lg border-2 border-holborn-blue hover:bg-holborn-blue hover:text-white">Learn More</Link>
                      </div>
                    </div>
                  </div>
                )}
                {webinarsImage && (
                  <div className="card relative bg-cover bg-center aspect-square rounded-3xl sm:col-span-1 md:col-span-1" style={{ backgroundImage: `url(${webinarsImage.images.fallback.src})` }}>
                    <div className="absolute inset-0 bg-black bg-opacity-0 flex flex-col justify-between p-8 md:px-4 xl:p-8 rounded-3xl">
                      <div className="text-left text-white">
                        <p className="featured-card-text pb-1 text-xl md:text-sm xl:text-xl">Read Our Insights</p>
                        <h3 className="featured-card-title text-2xl md:text-lg xl:text-3xl font-medium">Gain valuable knowledge from our experts</h3>
                      </div>
                      <div className="text-right">
                        <Link to="/blog/" className="card-button mt-3 bg-white text-black py-2 px-4 rounded-lg border-2 border-holborn-blue hover:bg-holborn-blue hover:text-white">Discover More</Link>
                      </div>
                    </div>
                  </div>
                )}
                {reviewsImage && (
                <div className="card sm:justify-center sm:mx-auto sm:w-1/2 md:w-full relative bg-cover bg-center aspect-square rounded-3xl sm:col-span-2 md:col-span-1" style={{ backgroundImage: `url(${reviewsImage.images.fallback.src})` }}>
                    <div className="absolute inset-0 bg-black bg-opacity-0 flex flex-col justify-between p-8 md:px-4 xl:p-8 rounded-3xl">
                      <div className="text-left text-white">
                        <p className="featured-card-text pb-1 text-xl md:text-sm xl:text-xl">Don't just take our word for it</p>
                        <h3 className="featured-card-title text-2xl md:text-lg xl:text-3xl font-medium">Read reviews from real clients</h3>
                      </div>
                      <div className="text-right">
                        <Link to="https://holbornassets.com/customer-reviews/" target="_blank" rel="noopener noreferrer" className="card-button mt-3 bg-white text-black py-2 px-4 rounded-lg border-2 border-holborn-blue hover:bg-holborn-blue hover:text-white">Read our reviews</Link>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
    );
};

export default FeaturedCards;